import {
    CalendarEventAction
} from 'angular-calendar';

import {
    startOfDay,
    endOfDay,
    subDays,
    addDays,
    endOfMonth,
    isSameDay,
    isSameMonth,
    addHours
} from 'date-fns';
// import { CalendarEvent } from 'calendar-utils/dist/calendar-utils';

/*
export interface EventAction
{
    label: string;
    cssClass?: string;

    onClick({event}: {
        event: CalendarEvent;
    }): any;
}*/

export class CalendarEventModel
{
    start: Date;
    end?: Date;
    title: string;
    color: {
        primary: string;
        secondary: string;
    };
    actions?: CalendarEventAction[];
    allDay?: boolean;
    cssClass?: string;
    resizable?: {
        beforeStart?: boolean;
        afterEnd?: boolean;
    };
    draggable?: boolean;
    meta?: {
        location: string;
        time: string;
        category: string;
        productId: string;
        productTitle: string;
        boarded: number;
        booked: number;
        pro: boolean;
        isClosed: boolean;
    };

    constructor(data?)
    {
        data = data || {};
        this.start = new Date(data.start) || startOfDay(new Date());
        this.end = new Date(data.end) || endOfDay(new Date());
        this.title = data.title || '';
        this.color = {
            primary  : data.color && data.color.primary || '#1e90ff',
            secondary: data.color && data.color.secondary || '#D1E8FF'
        };
        this.draggable = data.draggable || false;
        this.resizable = {
            beforeStart: data.resizable && data.resizable.beforeStart || false,
            afterEnd   : data.resizable && data.resizable.afterEnd || false
        };
        this.actions = data.actions || [];
        this.allDay = data.allDay || false;
        this.cssClass = data.cssClass || '';
        this.meta = {
            location: data.meta && data.meta.location || '',
            time: data.meta && data.meta.time || '',
            productId: data.meta && data.meta.productId || '',
            productTitle: data.meta && data.meta.productTitle || '',
            category: data.meta && data.meta.category || '',
            booked: data.meta && data.meta.booked || 0,
            boarded: data.meta && data.meta.boarded || 0,
            pro   : data.meta && data.meta.pro || false,
            isClosed   : data.meta && data.meta.isClosed || false
        };
    }

}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/calendar/event.model.ts